module.exports = __webpack_public_path__ + "img/HFIG-600.3b6135327cac83a6d909e10475fb7982.avif";